/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useState, useEffect } from "react";
// Material Kit 2 React examples
//import RotatingCard from "./RotatingCard";
//import RotatingCardFront from "./RotatingCardFront";
//import RotatingCardBack from "./RotatingCardBack";
//import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";
//import MKTypography from "components/MKTypography";
// Images
//import bgFront from "assets/images/rotating-card-bg-front.jpeg";
//import bgBack from "assets/images/rotating-card-bg-back.jpeg";
// eslint-disable-next-line
import kunnat from "kunnat";
import { FormControl, Select, MenuItem } from "@mui/material";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
//import MKTypography from "components/MKTypography";
// Material Kit 2 React components
import MKBox from "components/MKBox";
import DefaultCounterCard from "examples/Cards/CounterCards/DefaultCounterCard";
import stats from "stats";
//import Divider from "@mui/material/Divider";
import { Bar } from "react-chartjs-2";
import { CategoryScale } from "chart.js";
import Chart from "chart.js/auto";
import { useTranslation } from "react-i18next";
/* eslint-disable react/prop-types */
// eslint-disable-next-line
const InformationSelect = ({ selectedKunta, setSelectedKunta }) => {
  const [t] = useTranslation("common");
  const grouped = stats.reduce((acc, curr) => {
    Object.entries(curr).forEach(([property, v]) => {
      acc[property] = acc[property] || [];
      acc[property].push(+v); //+ for convert to a number before pushing
    });
    return acc;
  }, {});
  const info = [
    t("common.population"),
    t("common.birthmoretext"),
    t("common.migration"),
    t("common.economy"),
    t("common.urban"),
    t("common.rent"),
    t("common.secondschool"),
    t("common.highlevelschool"),
    t("common.work"),
    t("common.workrate"),
    t("common.pension"),
  ];
  const out = Object.entries(grouped).map(([property, v]) => {
    return {
      property,
      minValue: Math.min(...v), // min of an array. v is the array of numbers
      maxValue: Math.max(...v), //max of an array
      avg: v.reduce((a, b) => a + b) / v.length, //average of an array
    };
  });

  //console.log(out);
  Chart.register(CategoryScale);
  const [infor, setSelectedInfor] = useState(t("common.population"));
  const [selectedStats, setSelectedStats] = useState(
    stats.filter((i) => i.Kunta === selectedKunta)
  );
  const [avg, setAvg] = useState(5);
  const [min, setMin] = useState(3);
  const [max, setMax] = useState(9);
  const [mun, setMun] = useState(5);
  //console.log(kunnat);
  //console.log(setSelectedKunta);
  const getInfo = () =>
    info.map((i) => {
      return (
        <MenuItem value={i} key={i}>
          {i}
        </MenuItem>
      );
    });
  //console.log(selectedKunta);
  //console.log(selectedStats);
  useEffect(() => {
    setSelectedStats(stats.filter((i) => i.Kunta === selectedKunta));
    if (infor === t("common.population")) {
      setMin(out[1].minValue);
      setAvg(out[1].avg);
      setMax(out[1].maxValue);
      //console.log(selectedStats);
      //console.log(selectedKunta);
      setMun(selectedStats[0].Vakiluku);
    }
    if (infor === t("common.birthmoretext")) {
      setMin(out[2].minValue);
      setAvg(out[2].avg);
      setMax(out[2].maxValue);
      //console.log(selectedStats);
      //console.log(selectedKunta);
      setMun(selectedStats[0].Vakiluvun_muutos);
    }
    if (infor === t("common.economy")) {
      setMin(out[17].minValue);
      setAvg(out[17].avg);
      setMax(out[17].maxValue);
      //console.log(selectedStats);
      //console.log(selectedKunta);
      setMun(selectedStats[0].Taloudellinen_huoltosuhde);
    }
    if (infor === t("common.birthmoretext")) {
      setMin(out[9].minValue);
      setAvg(out[9].avg);
      setMax(out[9].maxValue);
      //console.log(selectedStats);
      //console.log(selectedKunta);
      setMun(selectedStats[0].Syntyneiden_enemmyys);
    }
    if (infor === t("common.urban")) {
      setMin(out[8].minValue);
      setAvg(out[8].avg);
      setMax(out[8].maxValue);
      //console.log(selectedStats);
      //console.log(selectedKunta);
      setMun(selectedStats[0].Taajamaa);
    }
    if (infor === t("common.rent")) {
      setMin(out[14].minValue);
      setAvg(out[14].avg);
      setMax(out[14].maxValue);
      //console.log(selectedStats);
      //console.log(selectedKunta);
      setMun(selectedStats[0].Vuokraasunnoissa_asuvia_asuntokunti);
    }
    if (infor === t("common.secondschool")) {
      setMin(out[15].minValue);
      setAvg(out[15].avg);
      setMax(out[15].maxValue);
      //console.log(selectedStats);
      //console.log(selectedKunta);
      setMun(selectedStats[0].Toisen_asteen_tutkinnon_suorittaneita_15v);
    }
    if (infor === t("common.highlevelschool")) {
      setMin(out[16].minValue);
      setAvg(out[16].avg);
      setMax(out[16].maxValue);
      //console.log(selectedStats);
      //console.log(selectedKunta);
      setMun(selectedStats[0].Korkeaasteen_tutkinnon_suorittaneita15v);
    }
    if (infor === t("common.work")) {
      setMin(out[18].minValue);
      setAvg(out[18].avg);
      setMax(out[18].maxValue);
      //console.log(selectedStats);
      //console.log(selectedKunta);
      setMun(selectedStats[0].Tyopaikkaomavaraisuus);
    }
    if (infor === t("common.workrate")) {
      setMin(out[20].minValue);
      setAvg(out[20].avg);
      setMax(out[20].maxValue);
      //console.log(selectedStats);
      //console.log(selectedKunta);
      setMun(selectedStats[0].Ika20_64v_tyollisyysaste);
    }
    if (infor === t("common.pension")) {
      setMin(out[23].minValue);
      setAvg(out[23].avg);
      setMax(out[23].maxValue);
      //console.log(selectedStats);
      //console.log(selectedKunta);
      setMun(selectedStats[0].Elakelaisia);
    }
    /**
     *  "Väkiluku",
  "Syntyvyys",
  "Muuttovoitto",
  "Taloudellinen huoltosuhde",
  "Taajama-aste",
  "Vuokra-asunnoissa asuvat",
  "Toisen asteen tutkinnot",
  "Korkea-asteen tutkinnot",
  "Työpaikkaomavaraisuus",
  "Työllisyysaste",
  "Eläkeläisten osuus",
     */
  }, [infor]);
  useEffect(() => {
    setSelectedStats(stats.filter((i) => i.Kunta === selectedKunta));
    if (infor === t("common.population")) {
      setMin(out[1].minValue);
      setAvg(out[1].avg);
      setMax(out[1].maxValue);
      //console.log(selectedStats);
      //console.log(selectedKunta);
      setMun(selectedStats[0].Vakiluku);
    }
    if (infor === t("common.migration")) {
      setMin(out[2].minValue);
      setAvg(out[2].avg);
      setMax(out[2].maxValue);
      //console.log(selectedStats);
      //console.log(selectedKunta);
      setMun(selectedStats[0].Vakiluvun_muutos);
    }
    if (infor === t("common.economy")) {
      setMin(out[17].minValue);
      setAvg(out[17].avg);
      setMax(out[17].maxValue);
      //console.log(selectedStats);
      //console.log(selectedKunta);
      setMun(selectedStats[0].Taloudellinen_huotosuhde);
    }
    if (infor === t("common.birthmore")) {
      setMin(out[9].minValue);
      setAvg(out[9].avg);
      setMax(out[9].maxValue);
      //console.log(selectedStats);
      //console.log(selectedKunta);
      setMun(selectedStats[0].Syntyneiden_enemmyys);
    }
    if (infor === t("common.urban")) {
      setMin(out[8].minValue);
      setAvg(out[8].avg);
      setMax(out[8].maxValue);
      //console.log(selectedStats);
      //console.log(selectedKunta);
      setMun(selectedStats[0].Taajamaa);
    }
    if (infor === t("common.rent")) {
      setMin(out[14].minValue);
      setAvg(out[14].avg);
      setMax(out[14].maxValue);
      //console.log(selectedStats);
      //console.log(selectedKunta);
      setMun(selectedStats[0].Vuokraasunnoissa_asuvia_asuntokunti);
    }
    if (infor === t("common.secondschool")) {
      setMin(out[15].minValue);
      setAvg(out[15].avg);
      setMax(out[15].maxValue);
      //console.log(selectedStats);
      //console.log(selectedKunta);
      setMun(selectedStats[0].Toisen_asteen_tutkinnon_suorittaneita_15v);
    }
    if (infor === t("common.highlevelschool")) {
      setMin(out[16].minValue);
      setAvg(out[16].avg);
      setMax(out[16].maxValue);
      //console.log(selectedStats);
      //console.log(selectedKunta);
      setMun(selectedStats[0].Korkaasteen_tutkinnon_suorittaneita15v);
    }
    if (infor === t("common.work")) {
      setMin(out[18].minValue);
      setAvg(out[18].avg);
      setMax(out[18].maxValue);
      //console.log(selectedStats);
      //console.log(selectedKunta);
      setMun(selectedStats[0].Tyopaikkaomavaraisuus);
    }
    if (infor === t("common.workrate")) {
      setMin(out[20].minValue);
      setAvg(out[20].avg);
      setMax(out[20].maxValue);
      //console.log(selectedStats);
      //console.log(selectedKunta);
      setMun(selectedStats[0].Ika20_64v_tyollisyysaste);
    }
    if (infor === t("common.pension")) {
      setMin(out[23].minValue);
      setAvg(out[23].avg);
      setMax(out[23].maxValue);
      //console.log(selectedStats);
      //console.log(selectedKunta);
      setMun(selectedStats[0].Elakelaisia);
    }
  }, []);
  const state = {
    labels: [t("common.min"), t("common.average"), t("common.max"), t("common.selected")],
    datasets: [
      {
        label: t("instructions.municipalitiesheader"),
        backgroundColor: "rgba(255,99,132,0.2)",
        borderColor: "rgba(255,99,132,1)",
        borderWidth: 1,
        hoverBackgroundColor: "rgba(255,99,132,0.4)",
        hoverBorderColor: "rgba(255,99,132,1)",
        data: [min, avg, max, mun],
      },
    ],
  };
  return (
    <>
      {t("common.selectinfo")}
      <FormControl fullWidth>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={infor}
          label={t("common.municipality")}
          onChange={(e) => setSelectedInfor(e.target.value)}
          style={{ backgroundColor: "white" }}
        >
          {getInfo()}
        </Select>
      </FormControl>
      <MKBox component="section" py={3}>
        <Container>
          <Grid container item xs={12} lg={9} sx={{ mx: "auto" }}>
            <Grid item xs={12} md={4}>
              <DefaultCounterCard
                count={min}
                suffix=""
                title={t("common.minvalue")}
                description={t("common.municipalitysinformation")}
              />
            </Grid>
            <Grid item xs={12} md={4} display="flex">
              <DefaultCounterCard
                count={avg}
                suffix=""
                title={t("common.average")}
                description={t("common.municipalitysinformation")}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <DefaultCounterCard
                count={max}
                suffix=""
                title={t("common.maxvalue")}
                description={t("common.municipalitysinformation")}
              />
            </Grid>
          </Grid>
        </Container>
      </MKBox>
      <DefaultCounterCard
        count={mun}
        suffix=""
        title={t("common.selectedmunicipalityvalue")}
        description={t("common.municipalitysinformation")}
      />
      <Bar width={"300%"} height={"100%"} data={state} />
    </>
  );
};

export default InformationSelect;

/**
 * 
 * <MKTypography
        variant="body1"
        color="black"
        textAlign="left"
        style={{ backgroundColor: "white" }}
      >
        {t("common.municipality")}
      </MKTypography>
 */
/**
 * 
 * <Grid item xs={12} lg={4} sx={{ mx: "auto" }}>
            <RotatingCard>
              <RotatingCardFront
                image={bgFront}
                icon="touch_app"
                title={
                  <>
                    {t("common.information")}
                    <br />
                    {t("common.aboutmunicipalities")}
                  </>
                }
                description={t("common.descriptioncard")}
              />
              <RotatingCardBack
                image={bgBack}
                title={t("common.moreinfo")}
                description={t("common.descriptioncardback")}
                action={{
                  type: "internal",
                  route: "/sections/page-sections/page-headers",
                  label: t("instructions.contactheader"),
                }}
              />
            </RotatingCard>
          </Grid>
 */
